export default {
  token: null,
  info: null,
  addvip: false,
  addvipType: null,
  readNotice: false,
};
